import projectsPageActionTypes from './actionTypes';
// @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
import createReducer from '../../../util/createReducer';

const INITIAL_STATE = {
  isDialogOpen: false,
  editProject: null,
};

const reducer = createReducer(INITIAL_STATE, {
  [projectsPageActionTypes.PROJECTS_PAGE_TOGGLE_DIALOG_OPEN]: (
    state: any,
    action: any,
  ) => {
    return {
      ...state,
      isDialogOpen: action.isOpen,
    };
  },
  [projectsPageActionTypes.PROJECTS_PAGE_SET_EDIT_PROJECT]: (
    state: any,
    action: any,
  ) => {
    return {
      ...state,
      editProject: action.project,
    };
  },
});

export default reducer;
